import React from "react";
import { Provider, } from "react-redux";

import Router from "./Router";
import store from "./store";
import injectGlobal from "./components/style/globalStyles";

// --------------------------------------------------

injectGlobal();

// --------------------------------------------------

const App = () => (
	<Provider store = { store }>
		<Router/>
	</Provider>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js